import React from 'react';
import {removeTrailingSlash} from 'utils/page-utils';
import {Redirect, useRouteMatch} from 'react-router-dom';
import PropTypes from 'prop-types';

/**
 * WithSsrRedirectTrailingSlash is a HOC that performs 301 redirects on SSR for urls ending with trailing slash to one without trailing slash.
 * This is requirement for marketing pages so that for SEO url without trailing slash is the source of truth.
 *
 * Example: https://spothero.com/about/rover/ will be 301 redirected to https://spothero.com/about/rover
 *
 * @param {React.ReactNode} EnhancedComponent Component to be enhanced
 * @returns {React.ReactNode} the component with enhancements
 */
const WithSsrRedirectTrailingSlash = EnhancedComponent => {
    const WrappedComponent = props => {
        const {url} = useRouteMatch();
        // staticContext prop is only available during SSR injected by StaticRouter
        const {staticContext} = props;

        // Check for staticContext to limit redirects to SSR only
        if (staticContext && url.endsWith('/')) {
            const newUrl = removeTrailingSlash(url);

            return <Redirect to={newUrl} />;
        }

        return <EnhancedComponent {...props} />;
    };

    WrappedComponent.propTypes = {
        staticContext: PropTypes.object,
    };

    return WrappedComponent;
};

WithSsrRedirectTrailingSlash.propTypes = {
    EnhancedComponent: PropTypes.element,
};

export default WithSsrRedirectTrailingSlash;
